import templateUrl from './google-map.html';

export const googleMapComponent = {
    bindings: {
        details: '<',
        onClose: '&',
        getLocationDetails: '&'
    },
    templateUrl,
    controller: class GoogleMapComponent {
        constructor(GoogleLocationService) {
            'ngInject';

            this.googleLocationService = GoogleLocationService;
        }

        $onInit() {
            this.isError = false;
            var map;
            this.addressDetails = {};
            
            let mapAttributes = {
                latlng: {
                    lat: (this.details && this.details.lat) ? this.details.lat : 37.09024,
                    lng: (this.details && this.details.lng) ? this.details.lng : -95.71289100000001
                },
                zoom : (this.details && this.details.lat && this.details.lng) ? 17 : 4
            };

            let mapElement = document.getElementById('map');

            map = new google.maps.Map(mapElement, {
                center: mapAttributes.latlng,
                zoom: mapAttributes.zoom
            });

            this.details = this.details || {};

            // Bounds for North America
            this.strictBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(28.70, -127.50),
                new google.maps.LatLng(48.85, -55.90)
            );

            this.getPlaceId(map, map.getCenter());
            this.addListener(map);
            this.mapDetails = {};
        }

        //add event Listener to new Map instance
        addListener(map) {
            //click Listener
            map.addListener('click', (e) => {
                this.placeMarkerAndPanTo(e.latLng, map);
            });

            //draged Listener
            map.addListener('dragend', () => {
                if (this.strictBounds.contains(map.getCenter())) return;

                var c = map.getCenter(),
                    x = c.lng(),
                    y = c.lat(),
                    maxX = this.strictBounds.getNorthEast().lng(),
                    maxY = this.strictBounds.getNorthEast().lat(),
                    minX = this.strictBounds.getSouthWest().lng(),
                    minY = this.strictBounds.getSouthWest().lat();

                if (x < minX) x = minX;
                if (x > maxX) x = maxX;
                if (y < minY) y = minY;
                if (y > maxY) y = maxY;

                map.setCenter(new google.maps.LatLng(y, x));
            });

            //zoom in out listener
            map.addListener('zoom_changed', () => {
                if (map.getZoom() < 5) map.setZoom(5);
            });
        }

        placeMarkerAndPanTo(latLng, map) {
            map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: latLng.lat(), lng: latLng.lng() },
                zoom: 17
            });

            this.addListener(map);
            this.getPlaceId(map, { lat: latLng.lat(), lng: latLng.lng() });
        }

        getDetails(map, placeId, latlng) {
            var infowindow = new google.maps.InfoWindow();
            var service = new google.maps.places.PlacesService(map);
            service.getDetails({
                placeId: placeId
            }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    this.mapDetails = place;
                    var marker = new google.maps.Marker({
                        map: map,
                        position: latlng
                    });
                    google.maps.event.addListener(marker, 'click', function () {
                        infowindow.setContent('<div><strong>' + place.name + '</strong><br>' +
                            place.formatted_address + '</div>');
                        infowindow.open(map, this);
                    });
                }
            });
        }

        getPlaceId(map, latlng) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'location': latlng }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    this.getDetails(map, results[0].place_id, latlng);
                }
            });
        }

        addressValidation({addressLine1 = '', cityName = '', stateName = ''}) {
            this.isError = (!addressLine1 || !cityName || !stateName) ? true : false;
            this.addressDetails.isError = this.isError;
        }

        onSubmit() {
            this.addressDetails = {};
            this.addressDetails.locationName = '';
            if (this.mapDetails.address_components) {
                this.isError = false;
                this.addressDetails = this.googleLocationService._formatAddress(this.mapDetails);
                this.addressDetails.status = this.details.status;
                this.addressDetails.addressId = this.details.addressId;
            } else {
                this.isError = true;
            }
            this.addressValidation(this.addressDetails);

            this.getLocationDetails({
                details: this.addressDetails
            });
            this.onClose();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/google-map/google-map.component.js